module.exports = __webpack_public_path__ + "static/img/point-icon@w.6121083.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-aa/point-icon@w.png
// module id = 07w9
// module chunks = 0